import { CardWithTitle } from "@common/CardWithTitle/CardWithTitle";
import { IAddonDetails, IBroadbandAddon, ISubscribedAddon } from "./interface/IAddonDetails";
import { Button, Stack, SvgIcon } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Addon } from "./Addon";
import plusIconImg from "@static/img/icons/plus.svg";
import { useStyle } from "./style";
import { useState } from "react";
import { AddAddonModal } from "@features/Addons/AddonModal/AddAddonModal";
import { RemoveAddonModal } from "@features/Addons/AddonModal/RemoveAddonModal";

export interface IParams {
    addonDetails: IAddonDetails;
    getAddonDetails(): void;
}

export const AddonDetails = (props: IParams) => {
    const { addonDetails, getAddonDetails } = props;
    const { classes } = useStyle({});
    const { t } = useTranslation(["addons", "common"]);

    const [selectedAddon, setSelectedAddon] = useState<IBroadbandAddon>();
    const [selectedSubscribedAddon, setSelectedSubscribedAddon] = useState<ISubscribedAddon>();

    const renderAddonDetails = (broadbandAddon: IBroadbandAddon) => {
        if (broadbandAddon.subscribedAddons.length === 0) {
            return <Addon broadbandAddon={broadbandAddon} onOpenModal={() => setSelectedAddon(broadbandAddon)} />;
        }

        return (
            <>
                {broadbandAddon.subscribedAddons.map((subscribedAddon) => (
                    <Addon
                        broadbandAddon={broadbandAddon}
                        key={subscribedAddon.id}
                        subscribedAddon={subscribedAddon}
                        onOpenModal={() => setSelectedSubscribedAddon(subscribedAddon)}
                    />
                ))}
                {broadbandAddon.subscribedAddons.length < broadbandAddon.maxQuantity && (
                    <div className={classes.addAddonContainer}>
                        <Button
                            color="secondary"
                            startIcon={
                                <SvgIcon className={classes.addonButtonImage} component={plusIconImg} inheritViewBox />
                            }
                            onClick={() => setSelectedAddon(broadbandAddon)}
                        >
                            <strong>{t("addons:addAddon", { description: broadbandAddon.description })}</strong>
                        </Button>
                    </div>
                )}
                {selectedSubscribedAddon && (
                    <RemoveAddonModal
                        addonId={selectedSubscribedAddon.id}
                        description={broadbandAddon.description}
                        getAddonDetails={getAddonDetails}
                        isRemoveAddonModalOpen={Boolean(selectedSubscribedAddon)}
                        serviceId={addonDetails.broadband.serviceId}
                        onClose={() => setSelectedSubscribedAddon(undefined)}
                    />
                )}
            </>
        );
    };

    return (
        <CardWithTitle title={t("addons:broadbandAddons")}>
            <Stack spacing={4}>{addonDetails.broadband.addons.map(renderAddonDetails)}</Stack>
            {selectedAddon && (
                <AddAddonModal
                    addon={selectedAddon}
                    getAddonDetails={getAddonDetails}
                    isAddAddonModalOpen={Boolean(selectedAddon)}
                    serviceId={addonDetails.broadband.serviceId}
                    onClose={() => setSelectedAddon(undefined)}
                />
            )}
        </CardWithTitle>
    );
};
